import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../common/config.service';
import { ServiceCustomerInfoApiOutputModel } from '../../models/api/customer.model';
import { HistorypayloadModel, OrderDetailsModel } from '../../models/api/my-trips.model';

@Injectable({
  providedIn: 'root'
})
export class MyTripsService {

  constructor(private configServ: ConfigService,
    private http: HttpClient) { }

  customerDetails(data: any) {
    return this.http.post<ServiceCustomerInfoApiOutputModel>(this.configServ.apiRoutes.CUSTOMER_DETAILS, data);
  }

  orderHistory(data: HistorypayloadModel) {
    return this.http.post<any>(this.configServ.apiRoutes.ORDER_HISTORY, data);
  }

  orderDetails(data: OrderDetailsModel) {
    return this.http.post<any>(this.configServ.apiRoutes.ORDER_DETAILS, data);
  }
}
